var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "ns-card" },
    [
      _c(
        "VCard",
        { staticClass: "card-type", class: _vm.context },
        [
          _c("VCardTitle", { attrs: { "primary-title": "" } }, [
            _c("div", { staticClass: "header-wrapper" }, [
              _c(
                "div",
                { staticClass: "header-left-content" },
                [
                  _vm.headerIcon.length > 0
                    ? _c("NsIcon", {
                        staticClass: "title-icon",
                        attrs: {
                          color: _vm.headerColor,
                          "icon-name": _vm.headerIcon,
                          size: "icon-md"
                        }
                      })
                    : _vm._e(),
                  _vm._t("header")
                ],
                2
              ),
              _vm._v(" "),
              _c("div", { staticClass: "header-right-content" }, [
                _vm.hasAction
                  ? _c(
                      "button",
                      {
                        staticClass: "action-button",
                        on: {
                          click: function($event) {
                            return _vm.$emit(
                              "onActionClick",
                              $event.target.value
                            )
                          }
                        }
                      },
                      [
                        _c("NsIcon", {
                          staticClass: "nsicon",
                          class: _vm.actionString.length > 0 ? "" : "no-text",
                          attrs: {
                            color: _vm.color,
                            "icon-name": _vm.actionIcon,
                            size: "icon-sm"
                          }
                        }),
                        _vm._v(" "),
                        _vm.actionString.length > 0
                          ? _c(
                              "span",
                              {
                                staticClass: "subtitle-small",
                                style: { color: _vm.color }
                              },
                              [_vm._v(_vm._s(_vm.actionString))]
                            )
                          : _vm._e()
                      ],
                      1
                    )
                  : _vm._e()
              ])
            ])
          ]),
          _vm._v(" "),
          _c(
            "VContainer",
            { staticClass: "card-body", attrs: { fluid: "" } },
            [_vm._t("content")],
            2
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }